export const dataHooks = {
  content: 'counter-badge-content',
};

export const SIZES = {
  small: 'small',
  medium: 'medium',
  tiny: 'tiny',
};
